'use client';

import { LegacyDialog } from '../../../components/dialog';
import { EditToolArgsForm } from './HITL/forms/EditToolArgsForm';

type EditToolArgsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (editedArgs: Record<string, unknown>) => void;
  toolName: string;
  args: Record<string, unknown>;
  hiddenFields?: string[];
};

export function EditToolArgsModal({
  isOpen,
  onClose,
  onSubmit,
  toolName,
  args,
  hiddenFields = [],
}: EditToolArgsModalProps) {
  return (
    <LegacyDialog.Root
      open={isOpen}
      onOpenChange={({ open }: { open: boolean }) => !open && onClose()}
      lazyMount
    >
      <LegacyDialog.Backdrop />
      <LegacyDialog.Positioner>
        <LegacyDialog.Content maxWidth="600px" width="90vw" maxHeight="80vh">
          <EditToolArgsForm
            onClose={onClose}
            onSubmit={onSubmit}
            toolName={toolName}
            args={args}
            hiddenFields={hiddenFields}
          />
        </LegacyDialog.Content>
      </LegacyDialog.Positioner>
    </LegacyDialog.Root>
  );
}
